<template>
    <div class="starDetail">
        <el-card shadow="never" class="box-card" style="margin-bottom: 8px;">
            <div class="affitem">
                <el-row>
                    <el-col :span="5">
                        <div class="headsrc"> <el-avatar :size="60" :src="dataInfo.headSrc"></el-avatar></div>
                    </el-col>
                    <el-col :span="15">
                        <div class="name">{{ dataInfo.name }}</div>
                        <div class="subdesc">{{ dataInfo.createTime }}</div>
                    </el-col>
                    <el-col :span="4">
                        <div class="goods">
                            <img v-if="dataInfo.isStarMark == 0" src="@/assets/img/emil/kx.png"
                                @click.stop="starMark">
                            <img v-if="dataInfo.isStarMark == 1" src="@/assets/img/emil/sx.png"
                                @click.stop="starMark">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <el-card shadow="never" class="box-card">
            <div class="emailcontent">
                <div class="subtitle">{{ dataInfo.subject }}</div>
                <div v-if="type == 'receive'" v-html="dataInfo.dealContent"></div>
                <div v-if="type == 'send'" v-html="dataInfo.dealEmailContentHtml"></div>
            </div>
        </el-card>
    </div>
</template>
<script>
import { QUERYEMAILSEND, QUERYEMAILRECEIVE, EMAILSENDSTARMARK } from '@/api/emial'
export default {
    data() {
        return {
            dataInfo: {},
            id: this.$route.query.id,
            type: this.$route.query.type,
        }
    },
    created() {
        this.getData(this.type, this.id)
    },
    methods: {
        getData(type, id) {
            if (type == 'send') {
                QUERYEMAILSEND({ id: id }).then(res => {
                    this.dataInfo = res.data.body
                })
            }
            if (type == 'receive') {
                QUERYEMAILRECEIVE({ id: id }).then(res => {
                    this.dataInfo = res.data.body
                })
            }
        },
        starMark() {
            if (this.type == 'send') {
                EMAILSENDSTARMARK({ id: this.id }).then(res => {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.getData(this.type, this.id)
            })
            }
            if (this.type == 'receive') {
                EMAILRECEIVESTARMARK({ id: this.id }).then(res => {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.getData(this.type, this.id)
            })
            }
        },
    }
}
</script>
<style lang="less" scoped>
.starDetail {
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 8px 8px 8px 8px;
    background-color: #fff;

    /deep/.el-card__body {
        padding: 8px !important;
    }

    .affitem {
        height: 60px;

        .headsrc {
            height: 60px;
            line-height: 60px;
        }

        .name {
            height: 30px;
            line-height: 30px;
            font-weight: 600;
            font-size: 14px;
        }

        .subdesc {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
        }

        .goods {
            display: flex;
            height: 60px;
            flex-direction: row;
            flex-wrap: nowrap;
            text-align: center;
            justify-content: flex-end;
            align-items: center;

            img {
                width: 35px;
                height: 35px;
            }
        }
    }

    .emailcontent {
        .subtitle {
            height: 35px;
        }
    }
}

.emailcontent {
    .subtitle {
        line-height: 40px;
        font-weight: 600;
        font-size: 17px;
    }
}
</style>